import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { GetEnumValuesDto } from 'src/app/core/api/models';
import { EnumToTextConvertorPipe } from 'src/app/core/pipes/enum-text.pipe';
import { SavedEnumsService } from 'src/app/core/services/saved-enums.service';
import { AppPrivateNumberSelectSearch } from 'src/app/core/types/app-private-number_select-search.type';
import {
  EnumsService,
  PrivateNumbersService,
} from '../../../core/api/services';
import { BaseChipListSelectSearch } from './base/base-chip-list-select-search.component';
import { BaseChipListSelectSearchModule } from './base/base-chip-list-select.search.module';
@Component({
    selector: 'private-numbers-chip-list-select-search',
    templateUrl: './base/base-chip-list-select-search-template.html',
    imports: [BaseChipListSelectSearchModule]
})
export class PrivateNumbersChipListSelectSearchComponent
  extends BaseChipListSelectSearch
  implements OnInit
{
  //#region properties
  @Input() type: AppPrivateNumberSelectSearch =
    'privateNumbersByOrganizationId';

  @Input() isAdminStats?: boolean;

  SmsCpEnumValues: GetEnumValuesDto[] = [];
  //#endregion

  constructor(
    protected currentService: PrivateNumbersService,
    private enumService: EnumsService,
    private enumToTextConvertorPipe: EnumToTextConvertorPipe
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.getEnumValuesApi('SmsCp')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsCpEnumValues = values));
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'optionTitle';
    if (!this.label) this.label = 'common.privateNumbers';
  }

  getItemsApi() {
    switch (this.type) {
      case 'privateNumbersForStatistics':
        this.optionValue = 'privateNumber';
        this.optionTitle = 'optionTitle';
        this.currentService
          .privateNumbersGetPrivateNumbersForStatistics({
            IsReturnDescendantPrivateNumbers: this.isAdminStats,
          })
          .pipe(
            this.basePipeOperators(),
            map((items) => {
              return items.data.map((item) => {
                return {
                  ...item,
                  optionTitle: `${item.privateNumber}`,
                };
              });
            })
          )
          .subscribe(this.baseObserver);
        break;
      case 'privateNumbersByOrganizationId':
        this.currentService
          .privateNumbersGetAllPrivateNumbersByOrganizationId({
            OrganizationId: this.id,
          })
          .pipe(
            this.basePipeOperators(),
            map((items) => {
              return items.data.map((item) => {
                const translatedSmsCp = this.enumToTextConvertorPipe.transform(
                  item.smsSenderAgentCp,
                  this.SmsCpEnumValues
                );
                return {
                  ...item,
                  optionTitle: `${item.number} (${translatedSmsCp})`,
                };
              });
            })
          )
          .subscribe(this.baseObserver);
        break;
    }
  }

  //get enum values
  getEnumValuesApi(enumName): Observable<GetEnumValuesDto[]> {
    if (SavedEnumsService.getEnum(enumName) != null)
      return SavedEnumsService.getEnumAsObservable(enumName);

    this.enumService
      .enumsGetEnumValues({ EnumTypeName: enumName })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((newEnum) => {
        SavedEnumsService.pushEnum({
          enumName: enumName,
          enumValue: newEnum?.data,
        });
      });

    // save enum
    return this.enumService.enumsGetEnumValues({ EnumTypeName: enumName }).pipe(
      takeUntil(this.onDestroy$),
      map((res) => res.data)
    );
  }
}
